import { AxiosRequestConfig } from 'axios';
import { URL_BACKEND_ROOT } from "../app/AppConst";
import { ApiClient } from '../util/ApiUtility';

/** Shared PDF download — fetches as blob and triggers a browser save. */
const downloadPdf = async (path: string, filename: string) => {
    const requestConfig: AxiosRequestConfig = {
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + path,
        responseType: 'blob',
    };
 
    const response = await ApiClient().request<Blob>(requestConfig);
 
    if (response.status >= 200 && response.status < 300) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } else {
        throw new Error("Амжилтгүй");
    }
};
 
/**
 * Downloads the auction purchase invoice (НЭХЭМЖЛЭХ) PDF for a listing.
 *
 *   <Button size="sm" onClick={() => downloadInvoice(data.id!)}>Invoice</Button>
 */
export const downloadInvoice = (listingId: number) =>
    downloadPdf(`/v1/cms/invoice/${listingId}/pdf`, `invoice-${listingId}.pdf`);
 
/**
 * Downloads the delivery handover receipt (ABOX хүргэлтийн баримт) PDF
 * for a listing. Gate on shipment existing (e.g. data.purchaseOrderId set
 * and shipment present) before showing the button.
 *
 *   <Button size="sm" onClick={() => downloadDeliveryReceipt(data.id!)}>Receipt</Button>
 */
export const downloadDeliveryReceipt = (listingId: number) =>
    downloadPdf(`/v1/cms/invoice/${listingId}/delivery-receipt`, `delivery-receipt-${listingId}.pdf`);

/**
 * Downloads the tax payment receipt (Төлбөрийн баримт) PDF for a listing.
 * Issued after payment lands; gate on the purchase order existing.
 *
 *   <Button size="sm" onClick={() => downloadPaymentReceipt(data.id!)}>Tax Receipt</Button>
 */
export const downloadPaymentReceipt = (listingId: number) =>
    downloadPdf(`/v1/cms/invoice/${listingId}/payment-receipt`, `payment-receipt-${listingId}.pdf`);